const PAYMENT_METHODS = {
  amex: 'amex',
  applePay: 'applePay',
  benefit: 'benefit',
  mada: 'mada',
  masterCard: 'masterCard',
  visa: 'visa',
  knet: 'knet',
}

export { PAYMENT_METHODS }

export default {
  APPLE_PAY: 'CheckoutApplePay',
  CREDIT_CARD: 'CheckoutCreditCard',
  MADA_CARD: 'CheckoutMadaCard',
  BANK_TRANSFER: 'BankTransfer',
  KNET_CARD: 'KnetCreditCard',
  TAMARA_PAY_CARD: 'TamaraPayCard',
}
